import { resetTitleBar } from '@/composables/menu/title'

export default defineNuxtPlugin(() => {
  resetTitleBar()
})
